module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec01_55e724ada7627b63f7478eba9fcf38af.jpg";